import React, { useState, useEffect } from 'react';
import './Login.css';
import './Account.css';
import CharacterList from './CharacterList';
import CreateCharacter from './Components/CreateCharacter/CreateCharacter';

function Account({ characterList = [], onClick, createInfo }) {
    const [showCreate, setShowCreate] = useState(false);
    const [currentTheme, setCurrentTheme] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        return savedTheme || 'default';
    });

    useEffect(() => {
        if (createInfo === null) {
            onClick('100');
        }
    }, [createInfo, onClick]);

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', currentTheme);
        localStorage.setItem('theme', currentTheme);
    }, [currentTheme]);

    const toggleCreate = () => {
        setShowCreate(!showCreate);
    }

    return (
        <div className="account-page">
            {showCreate ? (
                <CreateCharacter 
                    createInfo={createInfo} 
                    sendMessage={onClick} 
                    toggleCreate={toggleCreate}
                    currentTheme={currentTheme}
                    onThemeChange={setCurrentTheme}
                />
            ) : (
                <CharacterList 
                    characterList={characterList} 
                    onClick={onClick}
                    currentTheme={currentTheme}
                    onThemeChange={setCurrentTheme}
                    toggleCreate={toggleCreate}
                />
            )}
        </div>
    );
}

export default Account;